// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3qRCN","signatureBlock":"Footer_signatureBlock__1fDl0","signature":"Footer_signature__2gQjS"};